const gender = (state) => {
    return (
        state == "New Jersey" ?
            [
                "Select from the following...",
                "Female",
                "Male",
                "Unspecified"
            ]
            :
            [
                "Select from the following...",
                "Female",
                "Male"
            ]

    )
}

export default gender